import { FormLabel, Button, Paper, Stack, IconButton } from "@mui/material"

import PropTypes from 'prop-types';


export default function InputTemplate(props) {


    return (
        <Paper
            component="div"
            sx={{ display: 'flex', alignItems: 'center', width: "100%", boxShadow: "none" }}
        >
            <Stack direction="row" spacing={2}>
                <FormLabel variant="contained"
                    sx={{
                        marginTop: "5px",
                        paddingTop: "3.5px",
                        paddingLeft: "5px",
                        paddingRight: "5px",
                        paddingBottom: "3.5px",
                        color: "#555",
                        fontSize: '14px',
                        fontWeight: "700",
                        border: 1,
                        borderTopLeftRadius: 4,
                        borderBottomLeftRadius: 4,
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0,
                        lineHeight: props.lineHeight,
                        fontFamily: "Customfont !important",
                        backgroundColor: "#eee",
                        border: "1px solid #ccc",
                        textAlign: "center",
                        overflow: "revert",
                        textWrap: "nowrap",
                        height: props.titleHeight
                    }}

                >{props.icon != null ? <IconButton size="small">
                    {props.icon}
                </IconButton> : null}{props.title}</FormLabel>
            </Stack>
            {props.children}
        </Paper>
    )
}
InputTemplate.propTypes = {
    children: PropTypes.node,
    title: PropTypes.string,
    lineHeight: PropTypes.number,
    icon: PropTypes.node

}
InputTemplate.defaultProps = {
    lineHeight: 1.8,
    icon: null
}